module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_number_01_yellow-244f9734380cdc7b167e4e45068b2456.svg";